import { useState, useEffect } from 'react';
import { api, AuthenticateUser } from '../services/Api';

const UseAuth = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const recoveredUser = localStorage.getItem('userData');
        if (recoveredUser) {
            const parsedUser = JSON.parse(recoveredUser); 
            setUser(parsedUser);
            api.defaults.headers.Authorization = `Bearer ${parsedUser.token}`;
        }
        setLoading(false);
    }, []);

    const authenticate = async (username, password) => {
        try {
            const digitsOnly = username.replace(/\D/g, '');
            const cleanUsername = digitsOnly.length === 11 ? digitsOnly : username;
            const response = await AuthenticateUser(cleanUsername, password);
            const loggedUser = response.data.username;
            const role = response.data.role;
            const loggedUserAccess = response.data.access;
            const token = response.data.token;
            const stores = response.data.stores;
            const clientId = response.data.clientId;
            const userData = {
                username: loggedUser,
                role: role,
                access: loggedUserAccess,
                clientId: clientId,
                token: token,
                stores: stores
            };
            localStorage.setItem("userData", JSON.stringify(userData));
            api.defaults.headers.Authorization = `Bearer ${token}`;
            setUser(userData);
            return userData;
        } catch (err) {
            return null;
        }
    };

    const logout = () => {
        localStorage.removeItem("userData");
        api.defaults.headers.Authorization = null;
        setUser(null);
    };

    return {
        authenticated: !!user,
        user,
        loading,
        authenticate,
        logout,
    };
};

export default UseAuth;
